/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Delete_Terms_FailedInputs */

const en_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to delete some terms: ${i?.error}`)
};

const fr_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la suppression de certains termes : ${i?.error}`)
};

const de_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einige Begriffe konnten nicht gelöscht werden: ${i?.error}`)
};

const it_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare alcuni termini: ${i?.error}`)
};

const ru_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить некоторые термины: ${i?.error}`)
};

const es_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron eliminar algunos términos: ${i?.error}`)
};

const zh_cn2_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除某些术语失败：${i?.error}`)
};

const ja_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`いくつかの用語を削除できませんでした: ${i?.error}`)
};

const hi_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कुछ शब्दों को हटाने में विफलता: ${i?.error}`)
};

const pt_pt2_knp_terms_delete_terms_failed = /** @type {(inputs: Knp_Terms_Delete_Terms_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível excluir alguns termos: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to delete some terms: {error}" |
*
* @param {Knp_Terms_Delete_Terms_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_delete_terms_failed = /** @type {((inputs: Knp_Terms_Delete_Terms_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Delete_Terms_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_delete_terms_failed(inputs)
	if (locale === "de") return de_knp_terms_delete_terms_failed(inputs)
	if (locale === "it") return it_knp_terms_delete_terms_failed(inputs)
	if (locale === "ru") return ru_knp_terms_delete_terms_failed(inputs)
	if (locale === "es") return es_knp_terms_delete_terms_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_delete_terms_failed(inputs)
	if (locale === "ja") return ja_knp_terms_delete_terms_failed(inputs)
	if (locale === "hi") return hi_knp_terms_delete_terms_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_delete_terms_failed(inputs)
	return en_knp_terms_delete_terms_failed(inputs)
});